(function () {
    function callFunnelback(e, t) {
        $.ajax({
            method: "GET",
            url: $("#courses-search").attr("data-action"),
            data: {
                collection: "mqu~sp-micro-credentials",
                partial_query: e.term,
                show: "10",
                sort: "0",
                alpha: "0.5",
                fmt: "json++",
                profile: "result",
                _: new Date().getTime(),
            },
            dataType: "jsonp",
            success: function (e) {
                var n = [];
                e.forEach(function (e, t) {
                    e.action &&
                        n.push({
                            value: e.disp.title.replace(/<\/?[^>]+(>|$)/g, ""),
                            key: e.key,
                            action: e.action,
                        });
                }),
                    n.length ||
                        (n = [
                            {
                                label: "No matches found",
                                value: "#",
                            },
                        ]),
                    t(n),
                    n.length > 1
                        ? $(".ui-menu-count").html(
                              "Showing ".concat(n.length, " results")
                          )
                        : 1 == n.length &&
                          ("No matches found" == n[0].label
                              ? $(".ui-menu-count").html("")
                              : $(".ui-menu-count").html(
                                    "Showing ".concat(n.length, " result")
                                ));
            },
        });
    }

    function initAutocomplete() {
        $(".courses-search-reset").click(function () {
            $(".courses").removeClass("is-active-reset"),
                $("#courses-search-input").focus();
        }),
            ($("#courses-search-input")
                .autocomplete({
                    source: callFunnelback,
                    minLength: 3,
                    appendTo: ".courses-search",
                    select: function (e, t) {
                        return (
                            t.item.action &&
                                (window.location.href = t.item.action),
                            !1
                        );
                    },
                    open: function (e, t) {
                        $(".ui-menu-count").length ||
                            $(".ui-menu .ui-menu-item:first-child").prepend(
                                '<div class="ui-menu-count"></div>'
                            ),
                            navigator.userAgent.match(/(iPod|iPhone|iPad)/) &&
                                $(".ui-autocomplete").off(
                                    "menufocus hover mouseover"
                                ),
                            $(".courses").addClass("is-active"),
                            $("#courses-search-input").val()
                                ? $(".courses").addClass("is-active-reset")
                                : $(".courses").removeClass("is-active-reset");
                    },
                    close: function (e, t) {
                        $(".courses").removeClass("is-active"),
                            $("#courses-search-input").val() ||
                                $(".courses").removeClass("is-active-reset");
                    },
                })
                .data("ui-autocomplete")._renderItem = function (e, t) {
                return "No matches found" == t.label
                    ? $("<li>")
                          .data("ui-autocomplete-item", t)
                          .append(
                              '<div class="ui-menu-item-wrapper no-results">' +
                                  t.label +
                                  "</div>"
                          )
                          .appendTo(e)
                    : $("<li>")
                          .data("ui-autocomplete-item", t)
                          .append(
                              '<div class="ui-menu-item-wrapper">' +
                                  t.label +
                                  "</div>"
                          )
                          .appendTo(e);
            });
    }

    $("#courses-search-input").length > 0 && initAutocomplete();
})();
